<template>
    <div class="inner-box">
        <h2 class="title">{{title}}</h2>
        <div style="height:55px;"></div>
        <table class="visit-info-table">
            <tr>
                <th style="width:80px;">제목</th>
                <td>{{form.subject}}</td>
            </tr>
            <tr>
                <th>등록일</th>
                <td>{{form.regDtm}}</td>
            </tr>
            <tr>
                <th>조회수</th>
                <td>{{form.viewCnt}}</td>
            </tr>
            <tr>
                <th>내용</th>
                <td>
                    <vue-editor v-model="form.content" :disabled=true />
                </td>
            </tr>
            <tr v-if="form.files != ''">
                <th>파일</th>
                <td id="fileArea">
                    <div class="fileDisplay" v-for="file in form.files" :key="file.id">
                      <span class="fileList" @click="downloadFile(file.downloadUrl)">{{file.originalName}}</span>
                    </div>
                </td>
            </tr>
        </table>
        <div class="btn">
            <button @click="moveToList()">목록</button>
        </div>
    </div>
</template>
<script>
    import {VueEditor} from "vue2-editor"
    import $ from 'jquery'

    export default {
        name: 'BoardDetail',
        components: { VueEditor },
        props: {
            contentId: {
                type: String,
                required: false
            },
        },
        data(){
            return {
                compCd: "E0000001",
                title: "공지사항",
                category: "",
                authority: '',
                form: {
                    contentId: '',
                    subject: '',
                    writer: null,
                    writerId: '',
                    content: '',
                    comp_cd: '',
                    category: '공지사항',
                    viewCnt: '',
                    regDtm: '',
                    chgDtm: '',
                    files: ''
                }
            }
        },
        methods: {
            getContentItems(contentId) {
                this.$http.post(`/api/board/detail`, { id: contentId })
                    .then(response => {
                        this.form.contentId = response.data.id;
                        this.form.subject = response.data.subject;
                        this.form.content = response.data.content;
                        this.form.viewCnt = response.data.viewCnt;
                        this.form.regDtm = response.data.regDtm;
                        this.form.chgDtm = response.data.chgDtm;
                        this.form.files = response.data.files;
                    });
            },
            moveToList(){
                // this.$router.push({name: `noticeList`});
                this.$router.push({path: `/ijmt/board/` + this.category});
            },
            downloadFile(url) {
                this.$store.commit('loading');
                this.$http
                    .get(url, { responseType: 'blob' })
                    .then((response) => {
                        const downloadedfile = new Blob([response.data], { type: 'blob' });
                        let url;

                        const contentDisposition = response.headers['content-disposition'];
                        let fileName = 'unknown';
                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                            if (fileNameMatch.length === 2)
                                fileName = decodeURI(fileNameMatch[1]);
                        }

                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(downloadedfile, fileName);
                        } else {
                            url = window.URL.createObjectURL(downloadedfile);

                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }

                        this.$store.commit('finish');
                    });
            }

        },
        created() {
            if(location.href.indexOf('notice') > -1){
              this.title = "공지사항";
              this.category = "notice";
            }

            if(location.href.indexOf('faq') > -1){
              this.title = "FAQ";
              this.category = "faq";
            }

            this.getContentItems(this.contentId);
            this.authority = this.$store.state.loginInfo.authorities[0].roleCd;
        },
        mounted() {
            $('.ql-toolbar.ql-snow').css({
                "display": "none",
            });
            $('.ql-container.ql-snow').css({
                "border": "none"
            });
            $('.ql-editor').css({
                "padding": "0px"
            });
        }
    }
</script>
<style lang="scss" scoped>
    @import "public/css/bulma";

    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box ul{
        top: 30px;
        width: 100%;
        height: 60px;
        border:1px solid #d5d5d5;
    }

    .inner-box ul li{
        float: left;
        width: 33.3%;
        color: #888;
        text-align: center;
        display: block;
        line-height: 58px;
        font-weight: 700;
        border-right:1px solid #d5d5d5
    }

    .inner-box ul li:last-child{
        border-right:0;
    }

    .inner-box .on{
        background-color: #023e7c;
        color:#fff;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    table.visit-info-table td {
        border-bottom: 1px solid #ddd;
        color: #999;
        padding: 15px 0 15px 10px;
        font-size: 14px;
        vertical-align: middle;
    }

    table.visit-info-table th {
        border-bottom: 1px solid #ddd;
        color: #666;
        padding: 15px 10px 15px 10px;
        font-size: 14px;
        vertical-align: middle;
        background: #f9f9f9;
        text-align: center;
    }

    table.visit-info-table td input{
        width: 35%;
    }

    table.visit-info-table td p input{
        width: 100%;
    }

    table.visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    table.visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    table.visit-info-table td.tit-c{
        background: #f9f9f9;
        color: #666;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td.list-c{
        text-align: center;
    }

    table.visit-info-table td button{
        margin-left:10px;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box .btn{
        text-align:center;
    }

    .inner-box button:last-child{
        background-color: #b3b3b3;
        color:#fff;
    }

    .ql-toolbar.ql-snow{
        display: none;
        border: none;
    }

    .fileList{
        cursor: pointer;
        margin-right: 15px;
    }
</style>